module.exports = __webpack_public_path__ + "media/images/icons/double-quote-sans-right-d2df64bc09b8a9e0357d63027e049a07.svg";